import React, { useMemo } from "react";

import { MDBDataTable } from "mdbreact";
import { Card, CardBody } from "reactstrap";

//Rows and col's data
import dataTable from "./data/table-data";

import BadgesEllipsisSoft from "../../../../../../../../../../../../components/Common/BadgesEllipsisSoft";

import "./AgentList.scss";

//i18n
import { withTranslation } from "react-i18next";
import ButtonLogout from "../ButtonLogout";

const Index = ({ t, ...props }) => {
  const tableData = useMemo(() => {
    let data = [...props.tableData];

    data.forEach((row) => {
      row.logout = <ButtonLogout id={row.id} />;
      row.skills = row.skills.map && (
        <BadgesEllipsisSoft
          objItems={
            row?.skills
              ?.sort((a, b) => (a.length > b.length ? 1 : -1))
              .map((sk) => ({ name: sk })) || []
          }
          total={1}
        />
      );
    });

    return data;
  }, [props.tableData]);

  return (
    <Card className="mb-0 w-100">
      <CardBody className=" pb-0 px-0 mb-0 scroll">
        {props.loadingData ? (
          <div className="text-center">
            <span>{t("Loading...")}</span>
          </div>
        ) : Array.isArray(props.tableData) && props?.tableData?.length > 0 ? (
          <MDBDataTable
            className="agents-mdb-data-table"
            responsive
            hover
            columns={dataTable.columns.map((element) => ({
              ...element,
              label: t(element.label),
            }))}
            rows={tableData}
          />
        ) : (
          <div className="no-matching-records">
            <span>{t("No matching records found")}</span>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default withTranslation()(Index);
